import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISiteSAMLAttributeMapping } from '../types/ISiteSAMLConfiguration';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetSiteAttributeMappingRequest extends Request<ISiteSAMLAttributeMapping, IResult> {
  constructor(mapping: ISiteSAMLAttributeMapping) {
    super('setSiteAttributeMapping', mapping);
  }
}
